import { Dispatch } from 'redux'
import { NotificationEnum, NotificationType } from '../storeTypes'
import { ErrorResponse } from '../types'
import { PersistentStorage } from 'database/PersistentStorage'
import { CollectionNames } from 'database/constants'

export const markNotificationReadAction =
    (notification: NotificationType) => async () => {
        const rxInstance = await PersistentStorage.get()
        await rxInstance.addCollectionByName(CollectionNames.NOTIFICATIONS)

        await rxInstance.upsert(CollectionNames.NOTIFICATIONS, {
            ...notification,
            read_status: true
        })
    }

export const fetchUnreadNotificationsAction =
    () => async (dispatch: Dispatch) => {
        try {
            dispatch({ type: NotificationEnum.FETCHING_NOTIFICATION })

            const rxInstance = await PersistentStorage.get()
            await rxInstance.addCollectionByName(CollectionNames.NOTIFICATIONS)
            const hasStopped = rxInstance.hasStopped(
                CollectionNames.NOTIFICATIONS
            )

            const gottenNotifications = await rxInstance.find(
                CollectionNames.NOTIFICATIONS
            )

            dispatch({
                type: NotificationEnum.FETCH_NOTIFICATION_SUCCESS,
                payload: gottenNotifications
            })

            hasStopped &&
                rxInstance.syncCollection(
                    {},
                    {},
                    CollectionNames.NOTIFICATIONS,
                    (notifications: NotificationType[]) => {
                        const unreadNotifications = notifications.filter(
                            (notification) => !notification.read_status
                        )

                        dispatch({
                            type: NotificationEnum.HAS_UNREAD_NOTIFICATIONS,
                            payload: unreadNotifications.length > 0
                        })
                        dispatch({
                            type: NotificationEnum.FETCH_NOTIFICATION_SUCCESS,
                            payload: notifications
                        })
                    }
                )
        } catch (error: unknown) {
            if (error instanceof ErrorResponse) {
                dispatch({
                    type: NotificationEnum.FETCH_NOTIFICATION_FAILURE,
                    payload: error.response.data.detail
                })
            } else {
                dispatch({
                    type: NotificationEnum.FETCH_NOTIFICATION_FAILURE,
                    payload: 'Un problème est survenu'
                })
            }
        }
    }
